import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import AshbyLogo from './integrations/logos/ashby.png';
import ComeetLogo from './integrations/logos/comeet.png';
import GreenhouseLogo from './integrations/logos/greenhouse.png';
import HiringThingLogo from './integrations/logos/hiringthing.png';
import HRPartnerLogo from './integrations/logos/hrpartner.png';
import LACRMLogo from './integrations/logos/lacrm.png';
import LeverLogo from './integrations/logos/lever.png';
import RecruiteeLogo from './integrations/logos/recruitee.png';

import PennyProfile from './testimonials/pleo/penny.jpeg';
import PleoLogo from './testimonials/pleo/logo.svg';

import TryItNowArea from '../TryItNowArea';
import { Testimonial } from '../Testimonials';

import { Box, Divider, Grid, Link, Typography, useMediaQuery } from "@material-ui/core";
import { PrimaryHeading } from '../../components/Headings'
import { useTheme } from '@material-ui/styles';


const IntegrationsArea = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClickContactUs = e => {
    if (window.$crisp) {
      window.$crisp.push(["do", "chat:open"]);
      e.preventDefault();
    }
  };

  const supportHref = `mailto:${process.env.REACT_APP_CANVASS_SUPPORT_EMAIL}`;

  return (
    <Box mt={!isSmall ? 4 : 0}>
      <Box mb={5} textAlign="center">
        <PrimaryHeading>
          {t("We're integrated with your applicant tracking system")}
        </PrimaryHeading>
      </Box>
      <Box p={3}>
        {/* https://v4.mui.com/components/grid/#negative-margin */}
        <Grid container spacing={6} alignItems="center" justify="center">
          <Grid item xs={6} md={3}>
            <img src={GreenhouseLogo} alt={t('Greenhouse logo')} width="100%" />
          </Grid>
          <Grid item xs={6} md={3}>
            <img src={LeverLogo} alt={t('Lever logo')} width="100%" />
          </Grid>
          <Grid item xs={6} md={3}>
            <img src={AshbyLogo} alt={t('Ashby logo')} width="100%" />
          </Grid>
          <Grid item xs={6} md={3}>
            <img src={HiringThingLogo} alt={t('HiringThing logo')} width="100%" />
          </Grid>
          <Grid item xs={6} md={3}>
            <img src={RecruiteeLogo} alt={t('Tellent Recruitee logo')} width="100%" />
          </Grid>
          <Grid item xs={6} md={3}>
            <img src={ComeetLogo} alt={t('Comeet logo')} width="100%" />
          </Grid>
          <Grid item xs={6} md={3}>
            <img src={HRPartnerLogo} alt={t('HR Partner logo')} width="100%" />
          </Grid>
          <Grid item xs={6} md={3}>
            <img src={LACRMLogo} alt={t('Less Annoying CRM logo')} width="100%" />
          </Grid>
          <Grid xs={12}>
            <Box pt={2} textAlign="center">
              <Typography variant="subtitle2" >
                <Trans>
                  Don't see yours? <Link href={supportHref} onClick={handleClickContactUs}>Contact us</Link> as we have several more coming soon!
                </Trans>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

const IntegrationsPage = () => {
  return (
    <>
      <IntegrationsArea />
      <Box mt={8}>
        <Divider />
        <Box mt={8}>
          <Testimonial
            personName="Penny Onchere"
            personTitle="Commercial Talent Partner"
            personProfile={PennyProfile}
            companyName="Pleo"
            companyLogo={PleoLogo}
            paragraphs={[
              <Trans>
                Pleo has been on an amazing growth journey the past year and Canvass has really
                helped us scale our hiring process. For us the future of work is remote working
                and being able to have an asynchronous stage in our process has been great.
              </Trans>,
              <Trans>
                This allows candidates to complete the interview at a time that suits them and when
                they feel the most comfortable. Canvass increased the amount of candidates we could
                have in the process and the speed of which they could complete the process. This has
                been particularly useful for high volume roles.
              </Trans>,
              <Trans>
                The team has been so helpful and are really responsive to feedback and suggestions. It's
                been a pleasure working with them.
              </Trans>,
            ]}
          />
        </Box>
      </Box>
      <TryItNowArea />
    </>
  );
};

export default IntegrationsPage;
